/**
 * Tag-Service
 * 
 * Attila Németh, UBG
 * 28.02.2019
 */
 
import { Injectable } from '@angular/core';

import {ContentaService} from '../../contenta/services/contenta.service';

import {UbgTag} from '../model/tag';

@Injectable({
  providedIn: 'root'
})
export class UbgTagService {
  
  constructor(private contenta: ContentaService) {}
  
  get(id: string) {
    let promise = new Promise((resolve, reject) => {
      this.contenta.get('api/taxonomy_term/kampagnentags/' + id).then((response: {
        data: UbgTag
      }) => {
        resolve(response.data);
      }).catch(() => {
        reject();
      });
    });
    return promise;
  }
  
  getAll() {
    let promise = new Promise((resolve, reject) => {
      this.contenta.get('api/taxonomy_term/kampagnentags').then((response: {
        data: Array<UbgTag>
      }) => {
        resolve(response.data);
      }).catch(() => {
        reject();
      });
    });
    return promise;
  }

  getByTag(tag: string) {
    let promise = new Promise((resolve, reject) => {
      this.contenta.get('api/taxonomy_term/kampagnentags?filter[name]=' + tag).then((response: {
        data: Array<UbgTag>
      }) => {
        if (response.data.length > 0) {
          resolve(response.data[0]);
        }
        else {
          resolve(false);
        }
      }).catch(() => {
        reject();
      });
    });
    return promise;
  }
  
  create(tag: string) {
    let promise = new Promise((resolve, reject) => {
      this.contenta.post('api/taxonomy_term/kampagnentags', {
        data: {
          type: 'taxonomy_term--kampagnentags',
          attributes: {
            name: tag,
          }
        }
      }).then((response: {
        data: UbgTag,
      }) => {
        resolve(response.data);
      }).catch(() => {
        reject();
      });
    });
    return promise;
  }
    
}